export default __webpack_public_path__ + "static/media/purple_kindred_icon.4ffc1cb1.png";